import { Link } from 'react-router-dom';

import { Container } from '../components/Container';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { Seo } from '../components/Seo';
import type { Locale } from '../content/types';
import { localizedPaths } from '../lib/routes';
import { getSeoConfig } from '../lib/seo';

type NotFoundPageProps = {
  locale: Locale;
};

export function NotFoundPage({ locale }: NotFoundPageProps) {
  return (
    <>
      <Seo config={getSeoConfig('not-found', locale)} />
      <Header locale={locale} />
      <main className="not-found">
        <Container size="narrow">
          <p className="eyebrow">404</p>
          <h1>{locale === 'de' ? 'Seite nicht gefunden' : 'Page not found'}</h1>
          <p>
            {locale === 'de'
              ? 'Die gesuchte Seite existiert nicht oder wurde verschoben.'
              : 'The page you are looking for does not exist or has moved.'}
          </p>
          <Link className="button button--primary" to={localizedPaths.landing[locale]}>
            {locale === 'de' ? 'Zur Startseite' : 'Back to home'}
          </Link>
        </Container>
      </main>
      <Footer locale={locale} />
    </>
  );
}
